import React from 'react';

const IconUnchecked = (props) => (
  <svg viewBox="0 0 100 100" {...props}>
    <circle fill={props.color} cx="50" cy="50" r="40" />
  </svg>
);

export default IconUnchecked;
